import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'saffron-file-types',
  templateUrl: './file-types.component.html',
  styleUrls: ['./file-types.component.scss']
})
export class FileTypesComponent implements OnInit {

  @Input() isMultipartUpload: boolean = false;
  @Output() multipartChange = new EventEmitter<boolean>();

  public isEditing: boolean = true;

  constructor() { }

  ngOnInit(): void { }

  onToggleMultipart(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.multipartChange.emit(checked);
  }

}
